import { useAuth } from "contexts/AuthContext";
import { UserContext } from "contexts/UserContext";
import { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// material-ui
//import { useTheme } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import CardContent from "@mui/material/CardContent";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// project imports
import Avatar from "components/@extended/Avatar";
import MainCard from "components/MainCard";
import Transitions from "components/@extended/Transitions";
import IconButton from "components/@extended/IconButton";

// assets
import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
import UserOutlined from "@ant-design/icons/UserOutlined";
import avatarMan from "assets/images/manuser.png";
import avatarWoman from "assets/images/womanuser.png";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Link from "@mui/material/Link";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";

export default function Profile() {
  //const theme = useTheme();
  const navigate = useNavigate();
  const user = useContext(UserContext);
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!user) return <div>...</div>;

  return (
    <Box sx={{ flexShrink: 0, ml: "auto" }}>
      <Tooltip title="Profile" disableInteractive>
        <ButtonBase
          sx={(theme) => ({
            p: 0.25,
            borderRadius: 1,
            "&:focus-visible": {
              outline: `2px solid ${theme?.vars?.palette.secondary.dark}`,
              outlineOffset: 2,
            },
          })}
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? "profile-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Avatar
            alt="profile user"
            src={avatarMan}
            size="sm"
            sx={{
              "&:hover": { outline: "1px solid", outlineColor: "primary.main" },
            }}
          />
        </ButtonBase>
      </Tooltip>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 9],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions
            type="grow"
            position="top-right"
            in={open}
            {...TransitionProps}
          >
            <Paper
              sx={(theme) => ({
                //boxShadow: theme?.vars?.customShadows.z1,
                width: 290,
                minWidth: 240,
                maxWidth: { xs: 250, md: 290 },
              })}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard
                  elevation={0}
                  border={false}
                  content={false}
                  title=""
                  boxShadow={undefined}
                  subheader={undefined}
                  darkTitle={undefined}
                  secondary={undefined}
                  shadow={undefined}
                  ref={undefined}
                >
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Grid
                      container
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Grid>
                        <Stack
                          direction="row"
                          sx={{ gap: 1.25, alignItems: "center" }}
                        >
                          <Avatar
                            alt="profile user"
                            src={avatarMan}
                            sx={{ width: 32, height: 32 }}
                          />
                          <Stack>
                            <Typography variant="h6">
                              {user?.firstName} {user?.lastName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {user?.email}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid>
                        <Tooltip title="Logout">
                          <IconButton
                            size="large"
                            sx={{ color: "text.primary" }}
                            onClick={handleLogout}
                          >
                            <LogoutOutlined />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </CardContent>

                  <List
                    component="nav"
                    sx={{ p: 0, "& .MuiListItemIcon-root": { minWidth: 32 } }}
                  >
                    <Link
                      underline="none"
                      sx={{ color: "inherit" }}
                      onClick={() => {
                        navigate("/admin/showUser", {
                          state: { user_id: user?.user_id, user: user },
                        });
                        setOpen(false);
                      }}
                    >
                      <ListItemButton>
                        <ListItemIcon>
                          <UserOutlined />
                        </ListItemIcon>
                        <ListItemText primary="My User Data" />
                      </ListItemButton>
                    </Link>
                    <ListItemButton onClick={handleLogout}>
                      <ListItemIcon>
                        <LogoutOutlined />
                      </ListItemIcon>
                      <ListItemText primary="Logout" />
                    </ListItemButton>
                  </List>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
}
